import React, { Suspense } from 'react';

export const SignupComponent = React.lazy(() => import('./Signup'));

export const Signup = (props) => (
  <Suspense fallback={null}>
    <SignupComponent {...props} />
  </Suspense>
);
